import { IFinder, Finder } from "@/finder/IFinder";

export class Searcher {
    handlowiec: IFinder = new Finder();
    klient: IFinder = new Finder();
    filter: string=""
    komponent_finder:IFinder = new Finder()
    komponent_id:string|undefined;
    prj_id:any
    show_deleted:number=0;
    nr_wykrojnika:string | undefined;
    ksztalt_wykrojnika:string | undefined;
    wspolnota:string | undefined;

    x:number=0;
    y:number=0;
    tolerance=2;

    constructor() {
        this.init();
    }

    init() {
        this.handlowiec = new Finder();
        this.klient = new Finder();
        this.komponent_finder = new Finder();

        this.komponent_id=undefined;
        this.filter=""
        this.x=0;
        this.y=0;
        this.tolerance=2;
        this.show_deleted=0;
        this.nr_wykrojnika=undefined;
        this.ksztalt_wykrojnika=undefined;
        this.wspolnota=undefined;
    }


    init_from_JSON(searcherJSON:string) {
        const s:any=JSON.parse(searcherJSON)

        this.handlowiec         = s.handlowiec;
        this.klient             = s.klient;
        this.komponent_finder   = s.komponent_finder;

        this.komponent_id       = s.komponent_id;
        this.filter             = s.filter;
        this.x                  = s.x;
        this.y                  = s.y;
        this.tolerance          = s.tolerance;
        this.show_deleted       = s.show_deleted;
        this.nr_wykrojnika      = s.nr_wykrojnika
        this.ksztalt_wykrojnika = s.ksztalt_wykrojnika
        this.wspolnota          = s.wspolnota
    }

    async read() {
        console.log("searcher.read()")
        const searcherJSON = window.localStorage.getItem("searcher.json");
        if (!searcherJSON) this.init();
        else this.init_from_JSON(searcherJSON)
    }


    async save(searcher: Searcher ) {
       // alert(JSON.stringify(searcher))
        delete searcher.prj_id
        window.localStorage.setItem("searcher.json",JSON.stringify(searcher));
    }

}

